const Backbone = require('backbone');


const Model = new Backbone.Model({
	subtotal: 0.0,
	frete: 0.0,
	desconto: 0.0,
	total: 0.0,
	forma_entrega: '',
	forma_pagamento: '',
	endereco_id: 0,
	data_entrega: '',
	horarioentrega_id: 0
});

Model.on('change:subtotal change:frete change:desconto', function() {
	var subtotal = Model.get('subtotal');
	var frete = Model.get('frete');
	var desconto = Model.get('desconto');
	var total = subtotal + frete - desconto;
	Model.set('total',total);
});

Model.on('change:forma_entrega', function() {
	var forma_entrega = Model.get('forma_entrega');

	if (forma_entrega != 'Motoboy') {
		Model.set('frete', 0.0);
	}
});

Model.on('change:total',function() {
	var total = Model.get('total');
	var total = 'R$'+(total.number_format(2,',','.'));
	$('[name=total]').val(total);
	$('.valor-total').html(total);
});

var subtotal = $('[name=total]').data('subtotal')*1.0;
Model.set('subtotal',subtotal);

module.exports = Model;


//////////////////
// WEBPACK FOOTER
// ../src/carrinho/models/cart.js
// module id = 10
// module chunks = 0